"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonutChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableDonutChart_1 = require("./PluggableDonutChart");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var DonutChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(DonutChartDescriptor, _super);
    function DonutChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DonutChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableDonutChart_1.PluggableDonutChart(params); };
    };
    return DonutChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.DonutChartDescriptor = DonutChartDescriptor;
//# sourceMappingURL=DonutChartDescriptor.js.map